import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import "./index.css";
import "react-virtualized/styles.css";
import { persistor, store } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import PreviousRouteProvider from "./customHooks/context/PreviousRouteProvider";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { PostHogProvider } from "posthog-js/react";
import { Suspense } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
};

const PostHogWrapper = ({ children }) => {
  const enabled = import.meta.env.VITE_ENABLE_POSTHOG === "true";

  if (!enabled) return <>{children}</>;

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      {children}
    </PostHogProvider>
  );
};

const emotionCache = createCache({
  key: "css",
  speedy: true,
});

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <PostHogWrapper>
    <Suspense fallback={<div></div>}>
      <CacheProvider value={emotionCache}>
        <DndProvider backend={HTML5Backend}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              {/* v7 future flags: opt-in early (kills the two startup
                  deprecation warnings). startTransition wraps router state
                  updates; relativeSplatPath changes relative resolution inside
                  splat routes — our catch-all redirects absolutely, so no
                  behavior change. */}
              <BrowserRouter
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <PreviousRouteProvider>
                  <App />
                </PreviousRouteProvider>
              </BrowserRouter>
            </PersistGate>
          </Provider>
        </DndProvider>
      </CacheProvider>
    </Suspense>
  </PostHogWrapper>,
  // </React.StrictMode>,
);
